import { Link } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { useCart } from "../context/AppContext";
import { abs, money, TYPE_LABELS } from "../lib/api";
import { PageHeader } from "../components/PageHeader";

export default function Cart() {
  const { items, setQty, remove, subtotal, hasPhysical } = useCart();
  return (
    <div data-testid="cart-page">
      <PageHeader eyebrow="Your selection" title="Cart" />
      <div className="wb-container">
        {items.length === 0 ? (
          <div className="py-20" data-testid="cart-empty">
            <p className="muted">Your cart is empty.</p>
            <Link to="/shop" className="btn-gold mt-8" data-testid="cart-continue-shopping">Explore the shop</Link>
          </div>
        ) : (
          <div className="grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-8 divide-y" style={{ borderColor: "var(--wb-line)" }}>
              {items.map((i) => (
                <div key={i.product_id} className="flex gap-6 py-8 border-b wb-line" data-testid={`cart-item-${i.slug}`}>
                  <Link to={`/product/${i.slug}`} className="art-frame h-32 w-28 shrink-0"><img src={abs(i.image_url)} alt="" className="h-full w-full object-cover" /></Link>
                  <div className="flex flex-1 flex-col justify-between">
                    <div className="flex justify-between gap-4">
                      <div>
                        <div className="eyebrow">{TYPE_LABELS[i.type]}</div>
                        <Link to={`/product/${i.slug}`} className="mt-1 block font-display text-2xl hover:text-wb-gold transition-colors">{i.title}</Link>
                      </div>
                      <button onClick={() => remove(i.product_id)} className="muted hover:text-red-400 transition-colors h-fit" data-testid={`cart-remove-${i.slug}`} aria-label="Remove"><X size={18} /></button>
                    </div>
                    <div className="flex items-center justify-between">
                      {i.is_digital ? <span className="font-mono text-xs muted">Digital · qty 1</span> : (
                        <div className="flex items-center border wb-line">
                          <button className="p-2 muted hover:text-wb-gold" onClick={() => setQty(i.product_id, i.quantity - 1)} data-testid={`cart-qty-minus-${i.slug}`}><Minus size={12} /></button>
                          <span className="w-8 text-center font-mono text-sm" data-testid={`cart-qty-${i.slug}`}>{i.quantity}</span>
                          <button className="p-2 muted hover:text-wb-gold disabled:opacity-30" disabled={i.quantity >= i.max} onClick={() => setQty(i.product_id, i.quantity + 1)} data-testid={`cart-qty-plus-${i.slug}`}><Plus size={12} /></button>
                        </div>
                      )}
                      <span className="font-mono">{money(i.price * i.quantity)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <aside className="lg:col-span-4 wb-card p-8 h-fit">
              <div className="eyebrow">Summary</div>
              <div className="mt-6 flex justify-between text-sm"><span className="muted">Subtotal</span><span className="font-mono" data-testid="cart-subtotal">{money(subtotal)}</span></div>
              <div className="mt-3 flex justify-between text-sm"><span className="muted">Shipping</span><span className="font-mono text-xs muted">{hasPhysical ? "Calculated at checkout" : "Digital delivery"}</span></div>
              <Link to="/checkout" className="btn-gold mt-8 w-full" data-testid="cart-checkout-button">Proceed to checkout</Link>
            </aside>
          </div>
        )}
      </div>
    </div>
  );
}
